import type { GraphQLClient } from 'graphql-request';
import type { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BooleanType: { input: any; output: any; }
  CustomData: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  FloatType: { input: any; output: any; }
  IntType: { input: any; output: any; }
  ItemId: { input: any; output: any; }
  JsonField: { input: any; output: any; }
  MetaTagAttributes: { input: any; output: any; }
  UploadId: { input: any; output: any; }
};

export type AccordionModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  body?: InputMaybe<TextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AccordionModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type ArticleModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ArticleModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ArticleModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  author?: InputMaybe<StringFilter>;
  body?: InputMaybe<StructuredTextFilter>;
  category?: InputMaybe<LinksFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  excerpt?: InputMaybe<TextFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  importArticleId?: InputMaybe<IntegerFilter>;
  importTranslationId?: InputMaybe<IntegerFilter>;
  noIndex?: InputMaybe<BooleanFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  readTime?: InputMaybe<StringFilter>;
  seoMetadata?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ArticleModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Author_ASC = 'author_ASC',
  Author_DESC = 'author_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  ImportArticleId_ASC = 'importArticleId_ASC',
  ImportArticleId_DESC = 'importArticleId_DESC',
  ImportTranslationId_ASC = 'importTranslationId_ASC',
  ImportTranslationId_DESC = 'importTranslationId_DESC',
  NoIndex_ASC = 'noIndex_ASC',
  NoIndex_DESC = 'noIndex_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  ReadTime_ASC = 'readTime_ASC',
  ReadTime_DESC = 'readTime_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter Boolean fields */
export type BooleanFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type CategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum CategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export enum ColorBucketType {
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Cyan = 'cyan',
  Green = 'green',
  Grey = 'grey',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

export type CountryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CountryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CountryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  locations?: InputMaybe<LinksFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  rotationx?: InputMaybe<FloatFilter>;
  rotationy?: InputMaybe<FloatFilter>;
  texture?: InputMaybe<FileFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum CountryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Email_ASC = 'email_ASC',
  Email_DESC = 'email_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  Phone_ASC = 'phone_ASC',
  Phone_DESC = 'phone_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Rotationx_ASC = 'rotationx_ASC',
  Rotationx_DESC = 'rotationx_DESC',
  Rotationy_ASC = 'rotationy_ASC',
  Rotationy_DESC = 'rotationy_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter by creation datetime */
export type CreatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter DateTime fields */
export type DateTimeFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExposedArticleModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ExposedArticleModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ExposedArticleModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  article?: InputMaybe<LinkFilter>;
  category?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ExposedArticleModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type ExposedProjectModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ExposedProjectModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ExposedProjectModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  article?: InputMaybe<LinkFilter>;
  category?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ExposedProjectModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export enum FaviconType {
  AppleTouchIcon = 'appleTouchIcon',
  Icon = 'icon',
  MsApplication = 'msApplication'
}

/** Specifies how to filter Single-file/image fields */
export type FileFilter = {
  /** Search for records with an exact match. The specified value must be an Upload ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that have one of the specified uploads */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be an Upload ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records that do not have one of the specified uploads */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Specifies how to filter Floating-point fields */
export type FloatFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['FloatType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['FloatType']['input']>;
};

export type ImgixParams = {
  /**
   * Aspect Ratio
   *
   * Specifies an aspect ratio to maintain when resizing and cropping the image
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/aspect-ratio)
   */
  ar?: InputMaybe<Scalars['String']['input']>;
  /**
   * Automatic
   *
   * Applies automatic enhancements to images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/automatic)
   */
  auto?: InputMaybe<Array<ImgixParamsAuto>>;
  /**
   * Background Color
   *
   * Colors the background of padded and partially-transparent images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/background-color)
   */
  bg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Removal
   *
   * Removes background from image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal)
   */
  bgRemove?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-remove failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-fallback)
   */
  bgRemoveFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Foreground Type
   *
   * Specifies the image foreground type for background removal.
   *
   * Depends on: `bg-remove=true`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-foreground-type)
   */
  bgRemoveFgType?: InputMaybe<Array<ImgixParamsBgRemoveFgType>>;
  /**
   * Background Removal Semi Transparency
   *
   * Enables background removal while retaining semi-transparent areas.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-semi-transparency)
   */
  bgRemoveSemiTransparency?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement
   *
   * Replaces background from image using a string based prompt.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement)
   */
  bgReplace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Replace Fallback
   *
   * Overrides default fallback behavior for bg-replace failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replace-fallback)
   */
  bgReplaceFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement Negative Prompt
   *
   * Provides a negative text suggestion for background replacement.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement-negative-prompt)
   */
  bgReplaceNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend
   *
   * Specifies the location of the blend image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend)
   */
  blend?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Align
   *
   * Changes the blend alignment relative to the parent image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-align)
   */
  blendAlign?: InputMaybe<Array<ImgixParamsBlendAlign>>;
  /**
   * Blend Alpha
   *
   * Changes the alpha of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-alpha)
   */
  blendAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Color
   *
   * Specifies a color to use when applying the blend.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-color)
   */
  blendColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Crop
   *
   * Specifies the type of crop for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-crop)
   */
  blendCrop?: InputMaybe<Array<ImgixParamsBlendCrop>>;
  /**
   * Blend Fit
   *
   * Specifies the fit mode for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-fit)
   */
  blendFit?: InputMaybe<ImgixParamsBlendFit>;
  /**
   * Blend Height
   *
   * Adjusts the height of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-height)
   */
  blendH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend Mode
   *
   * Sets the blend mode for a blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-mode)
   */
  blendMode?: InputMaybe<ImgixParamsBlendMode>;
  /**
   * Blend Padding
   *
   * Applies padding to the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-padding)
   */
  blendPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Size
   *
   * Adjusts the size of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-size)
   */
  blendSize?: InputMaybe<ImgixParamsBlendSize>;
  /**
   * Blend Width
   *
   * Adjusts the width of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-width)
   */
  blendW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend X Position
   *
   * Adjusts the x-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-x-position)
   */
  blendX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Y Position
   *
   * Adjusts the y-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-y-position)
   */
  blendY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Gaussian Blur
   *
   * Applies a gaussian blur to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/gaussian-blur)
   */
  blur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Size & Color
   *
   * Applies a border to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size)
   */
  border?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Bottom
   *
   * Sets bottom border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-bottom)
   */
  borderBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Left
   *
   * Sets left border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-left)
   */
  borderLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Outer Border Radius
   *
   * Sets the outer radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/outer-border-radius)
   */
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Inner Border Radius
   *
   * Sets the inner radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/inner-border-radius)
   */
  borderRadiusInner?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Right
   *
   * Sets right border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-right)
   */
  borderRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Top
   *
   * Sets top border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-top)
   */
  borderTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Brightness
   *
   * Adjusts the brightness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/brightness)
   */
  bri?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Client Hints
   *
   * Sets one or more Client-Hints headers
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/client-hints)
   */
  ch?: InputMaybe<Array<ImgixParamsCh>>;
  /**
   * Chroma Subsampling
   *
   * Specifies the output chroma subsampling rate.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/chroma-subsampling)
   */
  chromasub?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Quantization
   *
   * Limits the number of unique colors in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-quantization)
   */
  colorquant?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Palette Color Count
   *
   * Specifies how many colors to include in a palette-extraction response.
   *
   * Depends on: `palette`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/palette-color-count)
   */
  colors?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Contrast
   *
   * Adjusts the contrast of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/contrast)
   */
  con?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Corner Radius
   *
   * Specifies the radius value for a rounded corner mask.
   *
   * Depends on: `mask=corners`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-corner-radius)
   */
  cornerRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Crop Mode
   *
   * Specifies how to crop an image.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/crop-mode)
   */
  crop?: InputMaybe<Array<ImgixParamsCrop>>;
  /**
   * Color Space
   *
   * Specifies the color space of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-space)
   */
  cs?: InputMaybe<ImgixParamsCs>;
  /**
   * Download
   *
   * Forces a URL to use send-file in its response.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/download)
   */
  dl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Dots Per Inch
   *
   * Sets the DPI value in the EXIF header.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/dots-per-inch)
   */
  dpi?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Device Pixel Ratio
   *
   * Adjusts the device-pixel ratio of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/device-pixel-ratio)
   */
  dpr?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Duotone
   *
   * Applies a duotone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone)
   */
  duotone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Duotone Alpha
   *
   * Changes the alpha of the duotone effect atop the source image.
   *
   * Depends on: `duotone`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone-alpha)
   */
  duotoneAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Exposure
   *
   * Adjusts the exposure of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/exposure)
   */
  exp?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Url Expiration Timestamp
   *
   * A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/expiration)
   */
  expires?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Blur
   *
   * Specifies the amount of blur to apply to detected faces. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-blur)
   */
  faceBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Pixelation
   *
   * Specifies the pixelation amount of the face.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-pixelation)
   */
  facePixel?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Index
   *
   * Selects a face to crop to.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-index)
   */
  faceindex?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Padding
   *
   * Adjusts padding around a selected face.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-padding)
   */
  facepad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Json Face Data
   *
   * Specifies that face data should be included in output when combined with `fm=json`.
   *
   * Depends on: `fm=json`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/json-face-data)
   */
  faces?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Mode
   *
   * Determines how to fill in additional space created by the fit setting
   *
   * Depends on: `fit`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-mode)
   */
  fill?: InputMaybe<ImgixParamsFill>;
  /**
   * Fill Color
   *
   * Sets the fill color for images with additional space created by the fit setting
   *
   * Depends on: `fill=solid`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-color)
   */
  fillColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Fallback
   *
   * Sets the fallback behavior for generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-fallback)
   */
  fillGenFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Fill Generative Negative Prompt
   *
   * Provides a negative text suggestion to the generative fill parameter. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-negative-prompt)
   */
  fillGenNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Position
   *
   * Sets the position of the Origin Image in relation to the generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-position)
   */
  fillGenPos?: InputMaybe<Array<ImgixParamsFillGenPos>>;
  /**
   * Fill Generative Prompt
   *
   * Provides a text suggestion to the generative fill parameter.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-prompt)
   */
  fillGenPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Seed
   *
   * Sets the generative seed value. Used to generate similar outputs from different prompts.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-seed)
   */
  fillGenSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Gradient Color Space
   *
   * Defines the color space as linear, sRGB, Oklab, HSL, or LCH for gradient color interpolation
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-color-space)
   */
  fillGradientCs?: InputMaybe<ImgixParamsFillGradientCs>;
  /**
   * Fill Gradient Linear
   *
   * Blends a gradient between two colors, {color1} and {color2}, along a straight path
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear)
   */
  fillGradientLinear?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Linear Direction
   *
   * The fill-gradient-linear-direction specifies the gradient's direction, flowing towards the bottom, top, right, or left
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear-direction)
   */
  fillGradientLinearDirection?: InputMaybe<Array<ImgixParamsFillGradientLinearDirection>>;
  /**
   * Fill Gradient Radial
   *
   * The fill-gradient-radial parameter creates a circular gradient transitioning from a central color (Color1) to an outer color (Color2)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial)
   */
  fillGradientRadial?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial Radius
   *
   * Parameter defines the radial gradient's radius as pixels or a percentage (0.0-1.0) of the image's smallest dimension
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-radius)
   */
  fillGradientRadialRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial X
   *
   * Specifies the location of the radial gradient's center along the x-axis, using either a pixel value or a floating point percentage (ranging from 0.0 to 1.0) of the image's width
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-x)
   */
  fillGradientRadialX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Radial Y
   *
   * Parameter sets the radial gradient's center on the y-axis, using pixels or a 0.0 to 1.0 percentage of the image's height
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-y)
   */
  fillGradientRadialY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Type
   *
   * Specifies if a gradient is radial (circular) or linear (straight)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-type)
   */
  fillGradientType?: InputMaybe<ImgixParamsFillGradientType>;
  /**
   * Resize Fit Mode
   *
   * Specifies how to map the source image to the output image dimensions.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/resize-fit-mode)
   */
  fit?: InputMaybe<ImgixParamsFit>;
  /**
   * Flip Axis
   *
   * Flips an image on a specified axis.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/flip-axis)
   */
  flip?: InputMaybe<ImgixParamsFlip>;
  /**
   * Output Format
   *
   * Changes the format of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-format)
   */
  fm?: InputMaybe<ImgixParamsFm>;
  /**
   * Focal Point Debug
   *
   * Displays crosshairs identifying the location of the set focal point
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-debug)
   */
  fpDebug?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Focal Point X Position
   *
   * Sets the relative horizontal value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-x-position)
   */
  fpX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Y Position
   *
   * Sets the relative vertical value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-y-position)
   */
  fpY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Zoom
   *
   * Sets the relative zoom value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-zoom)
   */
  fpZ?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frames Per Second
   *
   * Specifies the framerate of the generated image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frames-per-second)
   */
  fps?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Selection
   *
   * Specifies the frame of an animated image to use.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-selection)
   */
  frame?: InputMaybe<Scalars['String']['input']>;
  /**
   * Gamma
   *
   * Adjusts the gamma of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/gamma)
   */
  gam?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Animated Gif Quality
   *
   * Specifies the quality of the animated gif. The higher the value, the better more compression is applied.
   *
   * Depends on: `fm=gif`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/animated-gif-quality)
   */
  gifQ?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Grid Colors
   *
   * Sets grid colors for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-colors)
   */
  gridColors?: InputMaybe<Scalars['String']['input']>;
  /**
   * Grid Size
   *
   * Sets grid size for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-size)
   */
  gridSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Height
   *
   * Adjusts the height of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-height)
   */
  h?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Highlight
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/highlight)
   */
  high?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Halftone
   *
   * Applies a half-tone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/halftone)
   */
  htn?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Hue Shift
   *
   * Adjusts the hue of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/hue-shift)
   */
  hue?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Interval
   *
   * Displays every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-interval)
   */
  interval?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Invert
   *
   * Inverts the colors on the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/invert)
   */
  invert?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Iptc Passthrough
   *
   * Determine if IPTC data should be passed for JPEG images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/iptc-passthrough)
   */
  iptc?: InputMaybe<ImgixParamsIptc>;
  /**
   * Jpg Progressive
   *
   * Specifies whether or not a jpg/jpeg uses progressive (true) or baseline (false)
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/jpg-progressive)
   */
  jpgProgressive?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Animation Loop Count
   *
   * Specifies the number of times an animated image should repeat. A value of 0 means infinite looping.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation)
   */
  loop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Lossless Compression
   *
   * Specifies that the output image should be a lossless variant.
   *
   * Depends on: `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/lossless-compression)
   */
  lossless?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * License Plate Blur
   *
   * Specifies the amount of blur to apply to detected license plates. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/license-plate-detection/license-plate-blur)
   */
  lpBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Image Url
   *
   * Specifies the location of the watermark image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-image-url)
   */
  mark?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Alignment Mode
   *
   * Changes the watermark alignment relative to the parent image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alignment-mode)
   */
  markAlign?: InputMaybe<Array<ImgixParamsMarkAlign>>;
  /**
   * Watermark Alpha
   *
   * Changes the alpha of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alpha)
   */
  markAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Base Url
   *
   * Changes base URL of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-base-url)
   */
  markBase?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Fit Mode
   *
   * Specifies the fit mode for watermark images.
   *
   * Depends on: `mark`, `markw`, `markh`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-fit-mode)
   */
  markFit?: InputMaybe<ImgixParamsMarkFit>;
  /**
   * Watermark Height
   *
   * Adjusts the height of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-height)
   */
  markH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark If Minimum Height
   *
   * Displays the watermark if rendered base image pixel height is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-height)
   */
  markIfMinHeight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark If Minimum Width
   *
   * Displays the watermark if rendered base image pixel width is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-width)
   */
  markIfMinWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Padding
   *
   * Applies padding to the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-padding)
   */
  markPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Rotation
   *
   * Rotates a watermark or tiled watermarks by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-rotation)
   */
  markRot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark Scale
   *
   * Adjusts the scale of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-scale)
   */
  markScale?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Tile
   *
   * Adds tiled watermark.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-tile)
   */
  markTile?: InputMaybe<ImgixParamsMarkTile>;
  /**
   * Watermark Width
   *
   * Adjusts the width of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-width)
   */
  markW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark X Position
   *
   * Adjusts the x-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-x-position)
   */
  markX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Y Position
   *
   * Adjusts the y-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-y-position)
   */
  markY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Type
   *
   * Defines the type of mask and specifies the URL if that type is selected.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-type)
   */
  mask?: InputMaybe<Scalars['String']['input']>;
  /**
   * Mask Background Color
   *
   * Colors the background of the transparent mask area of images
   *
   * Depends on: `mask`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-background-color)
   */
  maskBg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum Height
   *
   * Specifies the maximum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-height)
   */
  maxH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Maximum Width
   *
   * Specifies the maximum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-width)
   */
  maxW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Height
   *
   * Specifies the minimum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-height)
   */
  minH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Width
   *
   * Specifies the minimum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-width)
   */
  minW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Monochrome
   *
   * Applies a monochrome effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/monochrome)
   */
  monochrome?: InputMaybe<Scalars['String']['input']>;
  /**
   * Noise Reduction Bound
   *
   * Reduces the noise in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-bound)
   */
  nr?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Noise Reduction Sharpen
   *
   * Provides a threshold by which to sharpen an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-sharpen)
   */
  nrs?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Object Removal Negative Prompt
   *
   * Provides a negative text suggestion to object-removal-prompt. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-negative-prompt)
   */
  objectRemovalNegativePrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Prompt
   *
   * Suggest auto generative fill for the object-removal-rect parameter
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-prompt)
   */
  objectRemovalPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal
   *
   * Using a specified rectangle, an object is removed from the image
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal)
   */
  objectRemovalRect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Seed
   *
   * Sets the generative seed value for object-removal. Used to generate new outputs from the same prompt
   *
   * Depends on: `object-removal-rect`, `object-removal-prompt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-seed)
   */
  objectRemovalSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Orientation
   *
   * Changes the image orientation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/orientation)
   */
  orient?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding
   *
   * Pads an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding)
   */
  pad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Bottom
   *
   * Sets bottom padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-bottom)
   */
  padBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Left
   *
   * Sets left padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-left)
   */
  padLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Right
   *
   * Sets right padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-right)
   */
  padRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Top
   *
   * Sets top padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-top)
   */
  padTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Pdf Page Number
   *
   * Selects a page from a PDF for display.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-page-number)
   */
  page?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Palette Extraction
   *
   * Specifies an output format for palette-extraction.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/color-palette-extraction)
   */
  palette?: InputMaybe<ImgixParamsPalette>;
  /**
   * Pdf Annotation
   *
   * Enables or disables PDF annotation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-annotation)
   */
  pdfAnnotation?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Css Prefix
   *
   * Specifies a CSS prefix for all classes in palette-extraction.
   *
   * Depends on: `palette=css`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/css-prefix)
   */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pixellate
   *
   * Applies a pixelation effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/pixellate)
   */
  px?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Output Quality
   *
   * Adjusts the quality of an output image.
   *
   * Depends on: `fm=avif`, `fm=jpg`, `fm=pjpg`, `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-quality)
   */
  q?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Rasterize Bypass
   *
   * Bypasses all rendering parameters (including default parameters) and serves the original image. Works for svg+xml,x-eps,pdf, and vnd.adobe.illustrator.
   */
  rasterizeBypass?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Source Rectangle Region
   *
   * Crops an image to a specified rectangle.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/source-rectangle-region)
   */
  rect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reverse
   *
   * Reverses the frame order on the source animation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/reverse)
   */
  reverse?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Rotation
   *
   * Rotates an image by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation)
   */
  rot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Rotation Type
   *
   * Changes the rotation type.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation-type)
   */
  rotType?: InputMaybe<ImgixParamsRotType>;
  /**
   * Saturation
   *
   * Adjusts the saturation of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/saturation)
   */
  sat?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Sepia Tone
   *
   * Applies a sepia effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/sepia-tone)
   */
  sepia?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Shadow
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/shadow)
   */
  shad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Sharpen
   *
   * Adjusts the sharpness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/sharpen)
   */
  sharp?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frame Skip
   *
   * Skips every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-skip)
   */
  skip?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Bypasses any [DatoCMS Automatic Image Optimization](https://www.datocms.com/docs/cdn-settings/advanced-asset-settings) that might be set up for the project.
   *
   * Exercise caution when using this parameter, as it could significantly increase your bandwidth costs.
   */
  skipDefaultOptimizations?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Sanitize Svg
   *
   * Specifies whether to sanitize an SVG.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/sanitize-svg)
   */
  svgSanitize?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Transparency
   *
   * Adds checkerboard behind images which support transparency.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/transparency)
   */
  transparency?: InputMaybe<ImgixParamsTransparency>;
  /**
   * Trim Image
   *
   * Trims the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-image)
   */
  trim?: InputMaybe<ImgixParamsTrim>;
  /**
   * Trim Alpha
   *
   * Specifies a trim alpha on a trim operation.
   *
   * Depends on: `trim=alpha`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-alpha)
   */
  trimAlpha?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Color
   *
   * Specifies a trim color on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-color)
   */
  trimColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Trim Mean Difference
   *
   * Specifies the mean difference on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-mean-difference)
   */
  trimMd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Padding
   *
   * Pads the area of the source image before trimming.
   *
   * Depends on: `trim`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-padding)
   */
  trimPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Trim Standard Deviation
   *
   * Specifies the standard deviation on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-standard-deviation)
   */
  trimSd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Tolerance
   *
   * Specifies the tolerance on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-tolerance)
   */
  trimTol?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text String
   *
   * Sets the text string to render.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-string)
   */
  txt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Align
   *
   * Sets the vertical and horizontal alignment of rendered text relative to the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-align)
   */
  txtAlign?: InputMaybe<Array<ImgixParamsTxtAlign>>;
  /**
   * Text Clipping Mode
   *
   * Sets the clipping properties of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-clipping-mode)
   */
  txtClip?: InputMaybe<Array<ImgixParamsTxtClip>>;
  /**
   * Text Color
   *
   * Specifies the color of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-color)
   */
  txtColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Fit Mode
   *
   * Specifies the fit approach for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-fit-mode)
   */
  txtFit?: InputMaybe<ImgixParamsTxtFit>;
  /**
   * Text Font
   *
   * Selects a font for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font)
   */
  txtFont?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Leading
   *
   * Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-leading)
   */
  txtLead?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline
   *
   * Outlines the rendered text with a specified color.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline)
   */
  txtLine?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline Color
   *
   * Specifies a text outline color.
   *
   * Depends on: `txt`, `txtline`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline-color)
   */
  txtLineColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Padding
   *
   * Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-padding)
   */
  txtPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Shadow
   *
   * Applies a shadow to rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-shadow)
   */
  txtShad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text Font Size
   *
   * Sets the font size of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font-size)
   */
  txtSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Tracking
   *
   * Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-tracking)
   */
  txtTrack?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Width
   *
   * Sets the width of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-width)
   */
  txtWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text X Position
   *
   * Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-x-position)
   */
  txtX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Y Position
   *
   * Sets the vertical (y) position of the text in pixels relative to the top edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-y-position)
   */
  txtY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Super Resolution
   *
   * Uses generative AI fill to upscale low resolution images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscale?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Super Resolution Fallback
   *
   * Overrides default fallback behavior for super resolution failures
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscaleFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Unsharp Mask
   *
   * Sharpens the source image using an unsharp mask.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask)
   */
  usm?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Unsharp Mask Radius
   *
   * Specifies the radius for an unsharp mask operation.
   *
   * Depends on: `usm`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask-radius)
   */
  usmrad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Vibrance
   *
   * Adjusts the vibrance of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/vibrance)
   */
  vib?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Width
   *
   * Adjusts the width of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-width)
   */
  w?: InputMaybe<Scalars['FloatType']['input']>;
};

export enum ImgixParamsAuto {
  Compress = 'compress',
  Enhance = 'enhance',
  Format = 'format',
  Redeye = 'redeye'
}

export enum ImgixParamsBgRemoveFgType {
  Auto = 'auto',
  Car = 'car'
}

export enum ImgixParamsBlendAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendCrop {
  Bottom = 'bottom',
  Faces = 'faces',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsBlendMode {
  Burn = 'burn',
  Color = 'color',
  Darken = 'darken',
  Difference = 'difference',
  Dodge = 'dodge',
  Exclusion = 'exclusion',
  Hardlight = 'hardlight',
  Hue = 'hue',
  Lighten = 'lighten',
  Luminosity = 'luminosity',
  Multiply = 'multiply',
  Normal = 'normal',
  Overlay = 'overlay',
  Saturation = 'saturation',
  Screen = 'screen',
  Softlight = 'softlight'
}

export enum ImgixParamsBlendSize {
  Inherit = 'inherit'
}

export enum ImgixParamsCh {
  Dpr = 'dpr',
  SaveData = 'saveData',
  Width = 'width'
}

export enum ImgixParamsCrop {
  Bottom = 'bottom',
  Edges = 'edges',
  Entropy = 'entropy',
  Faces = 'faces',
  Focalpoint = 'focalpoint',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsCs {
  Adobergb1998 = 'adobergb1998',
  Origin = 'origin',
  Srgb = 'srgb',
  Strip = 'strip',
  Tinysrgb = 'tinysrgb'
}

export enum ImgixParamsFill {
  Blur = 'blur',
  Gen = 'gen',
  Generative = 'generative',
  Gradient = 'gradient',
  Solid = 'solid'
}

export enum ImgixParamsFillGenPos {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientCs {
  Hsl = 'hsl',
  Lch = 'lch',
  Linear = 'linear',
  Oklab = 'oklab',
  Srgb = 'srgb'
}

export enum ImgixParamsFillGradientLinearDirection {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientType {
  Linear = 'linear',
  Radial = 'radial'
}

export enum ImgixParamsFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Facearea = 'facearea',
  Fill = 'fill',
  Fillmax = 'fillmax',
  Max = 'max',
  Min = 'min',
  Scale = 'scale'
}

export enum ImgixParamsFlip {
  H = 'h',
  Hv = 'hv',
  V = 'v'
}

export enum ImgixParamsFm {
  Avif = 'avif',
  Blurhash = 'blurhash',
  Gif = 'gif',
  Jp2 = 'jp2',
  Jpg = 'jpg',
  Json = 'json',
  Jxr = 'jxr',
  Mp4 = 'mp4',
  Pjpg = 'pjpg',
  Png = 'png',
  Png8 = 'png8',
  Png32 = 'png32',
  Webm = 'webm',
  Webp = 'webp'
}

export enum ImgixParamsIptc {
  Allow = 'allow',
  Block = 'block'
}

export enum ImgixParamsMarkAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsMarkFit {
  Clip = 'clip',
  Crop = 'crop',
  Fill = 'fill',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsMarkTile {
  Grid = 'grid'
}

export enum ImgixParamsPalette {
  Css = 'css',
  Json = 'json'
}

export enum ImgixParamsRotType {
  Pivot = 'pivot',
  Straighten = 'straighten'
}

export enum ImgixParamsTransparency {
  Grid = 'grid'
}

export enum ImgixParamsTrim {
  Alpha = 'alpha',
  Auto = 'auto',
  Color = 'color'
}

export enum ImgixParamsTxtAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsTxtClip {
  Ellipsis = 'ellipsis',
  End = 'end',
  Middle = 'middle',
  Start = 'start'
}

export enum ImgixParamsTxtFit {
  Max = 'max'
}

/** Specifies how to filter by usage */
export type InUseFilter = {
  /** Search uploads that are currently used by some record or not */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter Integer fields */
export type IntegerFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by ID */
export type ItemIdFilter = {
  /** Search the record with the specified ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude the record with the specified ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export enum ItemStatus {
  Draft = 'draft',
  Published = 'published',
  Updated = 'updated'
}

export type JobModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<JobModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<JobModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  body?: InputMaybe<TextFilter>;
  countrySelector?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  linkedinUrl?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringFilter>;
  noIndex?: InputMaybe<BooleanFilter>;
  pinned?: InputMaybe<BooleanFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  seoMetadata?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum JobModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CountrySelector_ASC = 'countrySelector_ASC',
  CountrySelector_DESC = 'countrySelector_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  LinkedinUrl_ASC = 'linkedinUrl_ASC',
  LinkedinUrl_DESC = 'linkedinUrl_DESC',
  Location_ASC = 'location_ASC',
  Location_DESC = 'location_DESC',
  NoIndex_ASC = 'noIndex_ASC',
  NoIndex_DESC = 'noIndex_DESC',
  Pinned_ASC = 'pinned_ASC',
  Pinned_DESC = 'pinned_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter JSON fields */
export type JsonFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter Single-link fields */
export type LinkFilter = {
  /** Search for records with an exact match. The specified value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records linked to one of the specified records */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be a Record ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records not linked to one of the specified records */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

/** Specifies how to filter Multiple-links fields */
export type LinksFilter = {
  /** Filter records linked to all of the specified records. The specified values must be Record IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records linked to at least one of the specified records. The specified values must be Record IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Search for records with an exact match. The specified values must be Record IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records not linked to any of the specified records. The specified values must be Record IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export type LocationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LocationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LocationModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  address?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum LocationModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Address_ASC = 'address_ASC',
  Address_DESC = 'address_DESC',
  City_ASC = 'city_ASC',
  City_DESC = 'city_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type LogoModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<LogoModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LogoModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  link?: InputMaybe<StringFilter>;
  logo?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum LogoModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Link_ASC = 'link_ASC',
  Link_DESC = 'link_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type MenuCorporateModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MenuCorporateModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MenuCorporateModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  externalLink?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  reference?: InputMaybe<LinkFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MenuCorporateModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  ExternalLink_ASC = 'externalLink_ASC',
  ExternalLink_DESC = 'externalLink_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type MenuCtaModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MenuCtaModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MenuCtaModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  externalLink?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  pageLink?: InputMaybe<LinkFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  primary?: InputMaybe<BooleanFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MenuCtaModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  ExternalLink_ASC = 'externalLink_ASC',
  ExternalLink_DESC = 'externalLink_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Primary_ASC = 'primary_ASC',
  Primary_DESC = 'primary_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type MenuFooterModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MenuFooterModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MenuFooterModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  externalLink?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  large?: InputMaybe<BooleanFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  reference?: InputMaybe<LinkFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MenuFooterModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  ExternalLink_ASC = 'externalLink_ASC',
  ExternalLink_DESC = 'externalLink_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Large_ASC = 'large_ASC',
  Large_DESC = 'large_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type MenuModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<MenuModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MenuModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  externalLink?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  large?: InputMaybe<BooleanFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  reference?: InputMaybe<LinkFilter>;
  separatorTitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum MenuModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  ExternalLink_ASC = 'externalLink_ASC',
  ExternalLink_DESC = 'externalLink_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Large_ASC = 'large_ASC',
  Large_DESC = 'large_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  SeparatorTitle_ASC = 'separatorTitle_ASC',
  SeparatorTitle_DESC = 'separatorTitle_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export enum MuxThumbnailFormatType {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png'
}

export type NumberStatisticModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<NumberStatisticModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NumberStatisticModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  number?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum NumberStatisticModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Number_ASC = 'number_ASC',
  Number_DESC = 'number_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter by image orientation */
export type OrientationFilter = {
  /** Search uploads with the specified orientation */
  eq?: InputMaybe<UploadOrientation>;
  /** Exclude uploads with the specified orientation */
  neq?: InputMaybe<UploadOrientation>;
};

export type PageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  noIndex?: InputMaybe<BooleanFilter>;
  position?: InputMaybe<PositionFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  seoMetadata?: InputMaybe<SeoFilter>;
  simpleLogoReference?: InputMaybe<LinkFilter>;
  simpleMenu?: InputMaybe<BooleanFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum PageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  NoIndex_ASC = 'noIndex_ASC',
  NoIndex_DESC = 'noIndex_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  SimpleMenu_ASC = 'simpleMenu_ASC',
  SimpleMenu_DESC = 'simpleMenu_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter by parent (tree-like collections only) */
export type ParentFilter = {
  /** Filter records children of the specified record. Value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with a parent record or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type PersonModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PersonModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PersonModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  lastName?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  role?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum PersonModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Email_ASC = 'email_ASC',
  Email_DESC = 'email_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  LastName_ASC = 'lastName_ASC',
  LastName_DESC = 'lastName_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  PhoneNumber_ASC = 'phoneNumber_ASC',
  PhoneNumber_DESC = 'phoneNumber_DESC',
  Role_ASC = 'role_ASC',
  Role_DESC = 'role_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter by position (sorted and tree-like collections) */
export type PositionFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export type ProjectCategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProjectCategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProjectCategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProjectCategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

export type ProjectModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProjectModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProjectModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  body?: InputMaybe<StructuredTextFilter>;
  client?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  duration?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  importProjectId?: InputMaybe<IntegerFilter>;
  importTranslationId?: InputMaybe<IntegerFilter>;
  location?: InputMaybe<StringFilter>;
  noIndex?: InputMaybe<BooleanFilter>;
  performedActivities?: InputMaybe<StringFilter>;
  position?: InputMaybe<PositionFilter>;
  projectCategory?: InputMaybe<LinkFilter>;
  publishTranslation?: InputMaybe<BooleanFilter>;
  seoMetadata?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ProjectModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Client_ASC = 'client_ASC',
  Client_DESC = 'client_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Description_ASC = 'description_ASC',
  Description_DESC = 'description_DESC',
  Duration_ASC = 'duration_ASC',
  Duration_DESC = 'duration_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  ImportProjectId_ASC = 'importProjectId_ASC',
  ImportProjectId_DESC = 'importProjectId_DESC',
  ImportTranslationId_ASC = 'importTranslationId_ASC',
  ImportTranslationId_DESC = 'importTranslationId_DESC',
  Location_ASC = 'location_ASC',
  Location_DESC = 'location_DESC',
  NoIndex_ASC = 'noIndex_ASC',
  NoIndex_DESC = 'noIndex_DESC',
  PerformedActivities_ASC = 'performedActivities_ASC',
  PerformedActivities_DESC = 'performedActivities_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  PublishTranslation_ASC = 'publishTranslation_ASC',
  PublishTranslation_DESC = 'publishTranslation_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter by publication datetime */
export type PublishedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecordBinModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<RecordBinModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<RecordBinModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  dateOfDeletion?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<ItemIdFilter>;
  label?: InputMaybe<StringFilter>;
  model?: InputMaybe<StringFilter>;
  recordBody?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum RecordBinModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  DateOfDeletion_ASC = 'dateOfDeletion_ASC',
  DateOfDeletion_DESC = 'dateOfDeletion_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Label_ASC = 'label_ASC',
  Label_DESC = 'label_DESC',
  Model_ASC = 'model_ASC',
  Model_DESC = 'model_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter by upload type */
export type ResolutionFilter = {
  /** Search uploads with the specified resolution */
  eq?: InputMaybe<ResolutionType>;
  /** Search uploads with the specified resolutions */
  in?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
  /** Exclude uploads with the specified resolution */
  neq?: InputMaybe<ResolutionType>;
  /** Search uploads without the specified resolutions */
  notIn?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
};

export enum ResolutionType {
  Icon = 'icon',
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

/** Specifies how to filter SEO meta tags fields */
export type SeoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

export enum SiteLocale {
  En = 'en',
  Es = 'es',
  It = 'it',
  Sl = 'sl'
}

/** Specifies how to filter Slug fields */
export type SlugFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that have one of the specified slugs */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do have one of the specified slugs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by status */
export type StatusFilter = {
  /** Search the record with the specified status */
  eq?: InputMaybe<ItemStatus>;
  /** Search records with the specified statuses */
  in?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  /** Exclude the record with the specified status */
  neq?: InputMaybe<ItemStatus>;
  /** Search records without the specified statuses */
  notIn?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
};

/** Specifies how to filter Single-line string fields */
export type StringFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that equal one of the specified values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do not equal one of the specified values */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StringMatchesFilter = {
  caseSensitive?: InputMaybe<Scalars['BooleanType']['input']>;
  pattern: Scalars['String']['input'];
  regexp?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter Structured Text fields values */
export type StructuredTextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or single empty paragraph) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type TestimonialModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TestimonialModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TestimonialModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  body?: InputMaybe<TextFilter>;
  company?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum TestimonialModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Company_ASC = 'company_ASC',
  Company_DESC = 'company_DESC',
  CreatedAt_ASC = 'createdAt_ASC',
  CreatedAt_DESC = 'createdAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Name_ASC = 'name_ASC',
  Name_DESC = 'name_DESC',
  UpdatedAt_ASC = 'updatedAt_ASC',
  UpdatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies how to filter text fields */
export type TextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by upload type */
export type TypeFilter = {
  /** Search uploads with the specified type */
  eq?: InputMaybe<UploadType>;
  /** Search uploads with the specified types */
  in?: InputMaybe<Array<InputMaybe<UploadType>>>;
  /** Exclude uploads with the specified type */
  neq?: InputMaybe<UploadType>;
  /** Search uploads without the specified types */
  notIn?: InputMaybe<Array<InputMaybe<UploadType>>>;
};

/** Specifies how to filter by update datetime */
export type UpdatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by default alt */
export type UploadAltFilter = {
  /** Search the uploads with the specified alt */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search uploads with the specified values as default alt */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the uploads with the specified alt */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search uploads that do not have the specified values as default alt */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by auhtor */
export type UploadAuthorFilter = {
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by basename */
export type UploadBasenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by colors */
export type UploadColorsFilter = {
  /** Filter uploads that have all of the specified colors */
  allIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have at least one of the specified colors */
  anyIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have the specified colors */
  contains?: InputMaybe<ColorBucketType>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that do not have any of the specified colors */
  notIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
};

/** Specifies how to filter by copyright */
export type UploadCopyrightFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by creation datetime */
export type UploadCreatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by filename */
export type UploadFilenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadFilter = {
  AND?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  _createdAt?: InputMaybe<UploadCreatedAtFilter>;
  _updatedAt?: InputMaybe<UploadUpdatedAtFilter>;
  alt?: InputMaybe<UploadAltFilter>;
  author?: InputMaybe<UploadAuthorFilter>;
  basename?: InputMaybe<UploadBasenameFilter>;
  colors?: InputMaybe<UploadColorsFilter>;
  copyright?: InputMaybe<UploadCopyrightFilter>;
  filename?: InputMaybe<UploadFilenameFilter>;
  format?: InputMaybe<UploadFormatFilter>;
  height?: InputMaybe<UploadHeightFilter>;
  id?: InputMaybe<UploadIdFilter>;
  inUse?: InputMaybe<InUseFilter>;
  md5?: InputMaybe<UploadMd5Filter>;
  mimeType?: InputMaybe<UploadMimeTypeFilter>;
  notes?: InputMaybe<UploadNotesFilter>;
  orientation?: InputMaybe<OrientationFilter>;
  resolution?: InputMaybe<ResolutionFilter>;
  size?: InputMaybe<UploadSizeFilter>;
  smartTags?: InputMaybe<UploadTagsFilter>;
  tags?: InputMaybe<UploadTagsFilter>;
  title?: InputMaybe<UploadTitleFilter>;
  type?: InputMaybe<TypeFilter>;
  width?: InputMaybe<UploadWidthFilter>;
};

/** Specifies how to filter by format */
export type UploadFormatFilter = {
  /** Search the asset with the specified format */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified formats */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified format */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified formats */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by height */
export type UploadHeightFilter = {
  /** Search assets with the specified height */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified height */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified height */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified height */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by ID */
export type UploadIdFilter = {
  /** Search the asset with the specified ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude the asset with the specified ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Specifies how to filter by MD5 */
export type UploadMd5Filter = {
  /** Search the asset with the specified MD5 */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified MD5s */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified MD5 */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified MD5s */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by mime type */
export type UploadMimeTypeFilter = {
  /** Search the asset with the specified mime type */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified mime types */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified mime type */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified mime types */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by notes */
export type UploadNotesFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Basename_ASC = 'basename_ASC',
  Basename_DESC = 'basename_DESC',
  Filename_ASC = 'filename_ASC',
  Filename_DESC = 'filename_DESC',
  Format_ASC = 'format_ASC',
  Format_DESC = 'format_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  MimeType_ASC = 'mimeType_ASC',
  MimeType_DESC = 'mimeType_DESC',
  Resolution_ASC = 'resolution_ASC',
  Resolution_DESC = 'resolution_DESC',
  Size_ASC = 'size_ASC',
  Size_DESC = 'size_DESC'
}

export enum UploadOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square'
}

/** Specifies how to filter by size */
export type UploadSizeFilter = {
  /** Search assets with the specified size (in bytes) */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified size (in bytes) */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified size (in bytes) */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified size (in bytes) */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by tags */
export type UploadTagsFilter = {
  /** Filter uploads linked to all of the specified tags */
  allIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to at least one of the specified tags */
  anyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to the specified tag */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads not linked to any of the specified tags */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Specifies how to filter by default title */
export type UploadTitleFilter = {
  /** Search the asset with the specified title */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter assets with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search assets with the specified as default title */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified title */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified as default title */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadType {
  Archive = 'archive',
  Audio = 'audio',
  Image = 'image',
  Pdfdocument = 'pdfdocument',
  Presentation = 'presentation',
  Richtext = 'richtext',
  Spreadsheet = 'spreadsheet',
  Video = 'video'
}

/** Specifies how to filter by update datetime */
export type UploadUpdatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by width */
export type UploadWidthFilter = {
  /** Search assets with the specified width */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified width */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified width */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified width */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export enum VideoMp4Res {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type AppQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  publishTranslation?: InputMaybe<Scalars['BooleanType']['input']>;
}>;


export type AppQuery = { _site: { locales: Array<SiteLocale>, globalSeo?: { siteName?: string | null, titleSuffix?: string | null } | null, favicon?: { url: string } | null, faviconMetaTags: Array<{ tag: string, content?: string | null, attributes?: any | null }> }, allMenus: Array<{ id: any, title?: string | null, large?: any | null, externalLink?: string | null, separatorTitle?: string | null, publishTranslation?: any | null, reference?: { __typename: 'PageRecord', title?: string | null, slug?: string | null } | null, blocks: Array<{ title?: string | null, description?: string | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', title?: string | null, slug?: string | null } | { __typename: 'PageRecord', title?: string | null, slug?: string | null } | { __typename: 'ProjectRecord', title?: string | null, slug?: string | null } | null, sublinks: Array<{ title?: string | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', title?: string | null, slug?: string | null } | { __typename: 'PageRecord', title?: string | null, slug?: string | null } | { __typename: 'ProjectRecord', title?: string | null, slug?: string | null } | null }>, secondarySublinks: Array<{ title?: string | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', title?: string | null, slug?: string | null } | { __typename: 'PageRecord', title?: string | null, slug?: string | null } | { __typename: 'ProjectRecord', title?: string | null, slug?: string | null } | null }> }> }>, allMenuCtas: Array<{ title?: string | null, primary?: any | null, externalLink?: string | null, pageLink?: { __typename: 'PageRecord', title?: string | null, slug?: string | null } | null }>, allMenuCorporates: Array<{ title?: string | null, externalLink?: string | null, publishTranslation?: any | null, reference?: { __typename: 'PageRecord', title?: string | null, slug?: string | null } | null }>, allMenuFooters: Array<{ id: any, title?: string | null, externalLink?: string | null, large?: any | null, publishTranslation?: any | null, reference?: { __typename: 'PageRecord', title?: string | null, slug?: string | null } | null, sublinks: Array<{ title?: string | null, externalLink?: string | null, reference?: { __typename: 'ArticleRecord', title?: string | null, slug?: string | null } | { __typename: 'PageRecord', title?: string | null, slug?: string | null } | { __typename: 'ProjectRecord', title?: string | null, slug?: string | null } | null }> }>, allCategories: Array<{ _modelApiKey: string, id: any, name?: string | null }>, allProjectCategories: Array<{ _modelApiKey: string, id: any, name?: string | null }>, allCountries: Array<{ name?: string | null, email?: string | null, phone?: string | null }> };

export type ArticlesQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>> | InputMaybe<Scalars['ItemId']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>> | InputMaybe<Scalars['ItemId']['input']>>;
  publishTranslation?: InputMaybe<Scalars['BooleanType']['input']>;
}>;


export type ArticlesQuery = { _allArticlesMeta: { count: any }, allArticles: Array<{ excerpt?: string | null, id: any, title?: string | null, slug?: string | null, publishTranslation?: any | null, noIndex?: any | null, category: Array<{ id: any, name?: string | null }>, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, mimeType: string, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

export type ArticleQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArticleQuery = { article?: { _modelApiKey: string, author?: string | null, createdAt: any, id: any, excerpt?: string | null, readTime?: string | null, title?: string | null, slug?: string | null, publishTranslation?: any | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, category: Array<{ id: any, name?: string | null }>, body?: { value: any, blocks: Array<{ __typename: 'AccordionListRecord', id: any, primary?: any | null, accordions: Array<{ title?: string | null, body?: string | null }> } | { __typename: 'BlockButtonRecord', id: any, label?: string | null, variant?: string | null, extLink?: string | null, intLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'BlockHtmlRecord', id: any, code?: string | null } | { __typename: 'HighlightImageRecord', id: any, style?: string | null, tag?: string | null, title?: string | null, background?: { alt?: string | null, url: string, width?: any | null, height?: any | null, mimeType: string, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HighlightQuoteRecord', id: any, title?: string | null } | { __typename: 'ImageGalleryRecord', id: any, images: Array<{ alt?: string | null, url: string, width?: any | null, height?: any | null, mimeType: string, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'ImageRecord', id: any, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'TableRecord', id: any, table?: any | null } | { __typename: 'VideoEmbedRecord', id: any, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }> } | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, mimeType: string, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

type SectionBlocks_AccordionListRecord_Fragment = {};

type SectionBlocks_SectionArticleListRecord_Fragment = { __typename: 'SectionArticleListRecord', _modelApiKey: string, id: any, itemsPerPage?: any | null, linkMore?: string | null, title?: string | null, categories: Array<{ name?: string | null, id: any }> };

type SectionBlocks_SectionBodyRecord_Fragment = { _modelApiKey: string, id: any, body?: { value: any, blocks: Array<{ __typename: 'AccordionListRecord', id: any, primary?: any | null, accordions: Array<{ title?: string | null, body?: string | null }> } | { __typename: 'BlockButtonRecord', id: any, label?: string | null, variant?: string | null, extLink?: string | null, intLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'BlockHtmlRecord', id: any, code?: string | null } | { __typename: 'CtaRecord' } | { __typename: 'HighlightImageRecord', id: any, style?: string | null, tag?: string | null, title?: string | null, background?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HighlightQuoteRecord', id: any, title?: string | null } | { __typename: 'ImageGalleryRecord', id: any, images: Array<{ responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'ImageRecord', id: any, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'TableRecord', id: any, table?: any | null } | { __typename: 'VideoEmbedRecord', id: any, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }> } | null };

type SectionBlocks_SectionClientListRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, clientList?: any | null, background?: string | null };

type SectionBlocks_SectionClientNumberListRecord_Fragment = { _modelApiKey: string, id: any, statistics: Array<{ title?: string | null, number?: string | null }> };

type SectionBlocks_SectionContactFormRecord_Fragment = { _modelApiKey: string, id: any, html?: string | null, title?: string | null, simple?: any | null, thankYouTitle?: string | null, thankYouSubtitle?: string | null, countries: Array<{ name?: string | null, email?: string | null, phone?: string | null, locations: Array<{ city?: string | null, address?: string | null }> }> };

type SectionBlocks_SectionCtaRecord_Fragment = { _modelApiKey: string, id: any, background?: string | null, title?: string | null, linkText?: string | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null };

type SectionBlocks_SectionFeaturesListRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, background?: string | null, features: Array<{ title?: string | null, body?: string | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, mediaBlocks: Array<{ _modelApiKey: string, id: any, loop?: any | null, autoplay?: any | null, media?: { url: string } | null }>, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null };

type SectionBlocks_SectionHighlightRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, leftColumn: Array<{ __typename: 'HighlightImageRecord', style?: string | null, tag?: string | null, title?: string | null, background?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HighlightQuoteRecord', title?: string | null }>, rightColumn: Array<{ style?: string | null, tag?: string | null, title?: string | null, background?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { title?: string | null }> };

type SectionBlocks_SectionImageGalleryRecord_Fragment = { _modelApiKey: string, id: any, background?: string | null, title?: string | null, images: Array<{ id: any, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> };

type SectionBlocks_SectionImageGalleryTwoRecord_Fragment = { _modelApiKey: string, id: any, images: Array<{ id: any, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> };

type SectionBlocks_SectionItemDetailRecord_Fragment = { _modelApiKey: string, id: any, leftText?: string | null, html?: string | null };

type SectionBlocks_SectionJobListingRecord_Fragment = { _modelApiKey: string, sectionId?: string | null, id: any, title?: string | null, subtitle?: string | null };

type SectionBlocks_SectionLocationRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, countries: Array<{ name?: string | null, email?: string | null, phone?: string | null, rotationx?: any | null, rotationy?: any | null, texture?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, locations: Array<{ city?: string | null, address?: string | null }> }> };

type SectionBlocks_SectionLogosListRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, logos: Array<{ name?: string | null, link?: string | null, logo?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

type SectionBlocks_SectionMediaBlockRecord_Fragment = { _modelApiKey: string, id: any, html?: string | null, mediaPosition?: string | null, mediaStyle?: string | null, title?: string | null, aboveTitle?: string | null, background?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, video?: { id: any, url: string } | null, logo?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null };

type SectionBlocks_SectionMultipleRecord_Fragment = { _modelApiKey: string, id: any, content: Array<{ tagline?: string | null, title?: string | null, body?: string | null, mediaStyle?: string | null, media?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> }> };

type SectionBlocks_SectionPeopleBlockRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, aboveTitle?: string | null, background?: string | null, people: Array<{ name?: string | null, lastName?: string | null, role?: string | null, phoneNumber?: string | null, email?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

type SectionBlocks_SectionProjectListRecord_Fragment = { __typename: 'SectionProjectListRecord', _modelApiKey: string, id: any, itemsPerPage?: any | null, linkMore?: string | null, title?: string | null, categories: Array<{ name?: string | null, id: any }> };

type SectionBlocks_SectionRelatedArticleRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, categories: Array<{ id: any, name?: string | null }>, overrideArticles: Array<{ excerpt?: string | null, id: any, title?: string | null, slug?: string | null, category: Array<{ id: any, name?: string | null }>, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

type SectionBlocks_SectionRoadmapRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, current?: any | null, entries: Array<{ title?: string | null, subtitle?: string | null }> };

type SectionBlocks_SectionServiceRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, background?: string | null, animation?: string | null, services: Array<{ title?: string | null, subtitle?: string | null, services?: string | null, description?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> }> };

type SectionBlocks_SectionSplit1Record_Fragment = { _modelApiKey: string, id: any, title?: string | null, bellowTitle?: string | null, fallbackImage?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, links: Array<{ title?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

type SectionBlocks_SectionSplit2Record_Fragment = { _modelApiKey: string, id: any, title?: string | null, bellowTitle?: string | null, links: Array<{ title?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

type SectionBlocks_SectionSplit3Record_Fragment = { _modelApiKey: string, id: any, aboveTitle?: string | null, links: Array<{ title?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

type SectionBlocks_SectionSplitRecord_Fragment = { _modelApiKey: string, id: any, aboveTitle?: string | null, links: Array<{ title?: string | null, color?: { hex: string } | null, reference?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

type SectionBlocks_SectionSplitTitleRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, subtitle?: string | null, links: Array<{ title?: string | null, color?: { hex: string } | null, reference?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> };

type SectionBlocks_SectionTestimonialsListRecord_Fragment = { _modelApiKey: string, id: any, testimonials: Array<{ body?: string | null, name?: string | null, company?: string | null }> };

type SectionBlocks_SectionTextBlockRecord_Fragment = { _modelApiKey: string, id: any, html?: string | null, title?: string | null, aboveTitle?: string | null, background?: string | null, box1?: string | null, box2?: string | null, box3?: string | null };

type SectionBlocks_SectionVideoRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null };

type SectionBlocks_SectionWorldwideRecord_Fragment = { _modelApiKey: string, id: any, title?: string | null, html?: string | null, media?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, mediaBlocks: Array<{ _modelApiKey: string, id: any, loop?: any | null, autoplay?: any | null, media?: { url: string } | null }>, countries: Array<{ name?: string | null, email?: string | null, phone?: string | null }> };

export type SectionBlocksFragment = SectionBlocks_AccordionListRecord_Fragment | SectionBlocks_SectionArticleListRecord_Fragment | SectionBlocks_SectionBodyRecord_Fragment | SectionBlocks_SectionClientListRecord_Fragment | SectionBlocks_SectionClientNumberListRecord_Fragment | SectionBlocks_SectionContactFormRecord_Fragment | SectionBlocks_SectionCtaRecord_Fragment | SectionBlocks_SectionFeaturesListRecord_Fragment | SectionBlocks_SectionHighlightRecord_Fragment | SectionBlocks_SectionImageGalleryRecord_Fragment | SectionBlocks_SectionImageGalleryTwoRecord_Fragment | SectionBlocks_SectionItemDetailRecord_Fragment | SectionBlocks_SectionJobListingRecord_Fragment | SectionBlocks_SectionLocationRecord_Fragment | SectionBlocks_SectionLogosListRecord_Fragment | SectionBlocks_SectionMediaBlockRecord_Fragment | SectionBlocks_SectionMultipleRecord_Fragment | SectionBlocks_SectionPeopleBlockRecord_Fragment | SectionBlocks_SectionProjectListRecord_Fragment | SectionBlocks_SectionRelatedArticleRecord_Fragment | SectionBlocks_SectionRoadmapRecord_Fragment | SectionBlocks_SectionServiceRecord_Fragment | SectionBlocks_SectionSplit1Record_Fragment | SectionBlocks_SectionSplit2Record_Fragment | SectionBlocks_SectionSplit3Record_Fragment | SectionBlocks_SectionSplitRecord_Fragment | SectionBlocks_SectionSplitTitleRecord_Fragment | SectionBlocks_SectionTestimonialsListRecord_Fragment | SectionBlocks_SectionTextBlockRecord_Fragment | SectionBlocks_SectionVideoRecord_Fragment | SectionBlocks_SectionWorldwideRecord_Fragment;

export type ExposedArticlesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
}>;


export type ExposedArticlesQuery = { _allExposedArticlesMeta: { count: any }, allExposedArticles: Array<{ article?: { title?: string | null, excerpt?: string | null, id: any, slug?: string | null, category: Array<{ id: any, name?: string | null }>, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | null }> };

export type ExposedProjectsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
}>;


export type ExposedProjectsQuery = { _allExposedProjectsMeta: { count: any }, allExposedProjects: Array<{ article?: { title?: string | null, client?: string | null, location?: string | null, performedActivities?: string | null, description?: string | null, duration?: string | null, id: any, projectCategory?: { id: any, name?: string | null } | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | null }> };

export type PageFragment = { id: any, slug?: string | null, title?: string | null, publishTranslation?: any | null, noIndex?: any | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null };

export type ImageFragment = { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null };

export type CallToActionFragment = { externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null };

type HeroBlocks_SectionHeroB1Record_Fragment = { _modelApiKey: string, tag?: string | null, title?: string | null, body?: string | null, parallaxVariant?: string | null, heroVideo?: { id: any, title?: string | null, url: string } | null, layers: Array<{ media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, desktopMedia?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

type HeroBlocks_SectionHeroItemRecord_Fragment = { _modelApiKey: string, client?: string | null, project?: string | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null };

type HeroBlocks_SectionHeroRecord_Fragment = { _modelApiKey: string, title?: string | null, html?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, heroVideo?: { id: any, title?: string | null, url: string } | null, heroVideoWebm?: { id: any, title?: string | null, url: string } | null, layers: Array<{ media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, desktopMedia?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

type HeroBlocks_SectionHeroSimpleRecord_Fragment = { _modelApiKey: string, tag?: string | null, title?: string | null, html?: string | null, background?: string | null, tagLink?: { __typename: 'PageRecord', id: any, slug?: string | null } | null, subpages: Array<{ __typename: 'PageRecord', id: any, slug?: string | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, person?: { name?: string | null, lastName?: string | null, role?: string | null, phoneNumber?: string | null, email?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | null };

type HeroBlocks_SectionTitle2Record_Fragment = { _modelApiKey: string, createdAt: any, title?: string | null, aboveTitle?: string | null };

type HeroBlocks_SectionTitleRecord_Fragment = { _modelApiKey: string, title?: string | null, html?: string | null };

export type HeroBlocksFragment = HeroBlocks_SectionHeroB1Record_Fragment | HeroBlocks_SectionHeroItemRecord_Fragment | HeroBlocks_SectionHeroRecord_Fragment | HeroBlocks_SectionHeroSimpleRecord_Fragment | HeroBlocks_SectionTitle2Record_Fragment | HeroBlocks_SectionTitleRecord_Fragment;

export type IndexQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type IndexQuery = { index?: { _modelApiKey: string, title?: string | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, hero: Array<{ __typename: 'SectionHeroB1Record', _modelApiKey: string, tag?: string | null, title?: string | null, body?: string | null, parallaxVariant?: string | null, heroVideo?: { id: any, title?: string | null, url: string } | null, layers: Array<{ media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, desktopMedia?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionHeroItemRecord', _modelApiKey: string, client?: string | null, project?: string | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionHeroRecord', _modelApiKey: string, title?: string | null, html?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, heroVideo?: { id: any, title?: string | null, url: string } | null, heroVideoWebm?: { id: any, title?: string | null, url: string } | null, layers: Array<{ media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, desktopMedia?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionHeroSimpleRecord', _modelApiKey: string, tag?: string | null, title?: string | null, html?: string | null, background?: string | null, tagLink?: { __typename: 'PageRecord', id: any, slug?: string | null } | null, subpages: Array<{ __typename: 'PageRecord', id: any, slug?: string | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, person?: { name?: string | null, lastName?: string | null, role?: string | null, phoneNumber?: string | null, email?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | null } | { __typename: 'SectionTitle2Record', _modelApiKey: string, createdAt: any, title?: string | null, aboveTitle?: string | null } | { __typename: 'SectionTitleRecord', _modelApiKey: string, title?: string | null, html?: string | null }>, blocks: Array<{ __typename: 'AccordionListRecord' } | { __typename: 'SectionArticleListRecord', _modelApiKey: string, id: any, itemsPerPage?: any | null, linkMore?: string | null, title?: string | null, categories: Array<{ name?: string | null, id: any }> } | { __typename: 'SectionBodyRecord', _modelApiKey: string, id: any, body?: { value: any, blocks: Array<{ __typename: 'AccordionListRecord', id: any, primary?: any | null, accordions: Array<{ title?: string | null, body?: string | null }> } | { __typename: 'BlockButtonRecord', id: any, label?: string | null, variant?: string | null, extLink?: string | null, intLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'BlockHtmlRecord', id: any, code?: string | null } | { __typename: 'CtaRecord' } | { __typename: 'HighlightImageRecord', id: any, style?: string | null, tag?: string | null, title?: string | null, background?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HighlightQuoteRecord', id: any, title?: string | null } | { __typename: 'ImageGalleryRecord', id: any, images: Array<{ responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'ImageRecord', id: any, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'TableRecord', id: any, table?: any | null } | { __typename: 'VideoEmbedRecord', id: any, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }> } | null } | { __typename: 'SectionClientListRecord', _modelApiKey: string, id: any, title?: string | null, clientList?: any | null, background?: string | null } | { __typename: 'SectionClientNumberListRecord', _modelApiKey: string, id: any, statistics: Array<{ title?: string | null, number?: string | null }> } | { __typename: 'SectionContactFormRecord', _modelApiKey: string, id: any, html?: string | null, title?: string | null, simple?: any | null, thankYouTitle?: string | null, thankYouSubtitle?: string | null, countries: Array<{ name?: string | null, email?: string | null, phone?: string | null, locations: Array<{ city?: string | null, address?: string | null }> }> } | { __typename: 'SectionCtaRecord', _modelApiKey: string, id: any, background?: string | null, title?: string | null, linkText?: string | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'SectionFeaturesListRecord', _modelApiKey: string, id: any, title?: string | null, background?: string | null, features: Array<{ title?: string | null, body?: string | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, mediaBlocks: Array<{ _modelApiKey: string, id: any, loop?: any | null, autoplay?: any | null, media?: { url: string } | null }>, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionHighlightRecord', _modelApiKey: string, id: any, title?: string | null, leftColumn: Array<{ __typename: 'HighlightImageRecord', style?: string | null, tag?: string | null, title?: string | null, background?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HighlightQuoteRecord', title?: string | null }>, rightColumn: Array<{ style?: string | null, tag?: string | null, title?: string | null, background?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { title?: string | null }> } | { __typename: 'SectionImageGalleryRecord', _modelApiKey: string, id: any, background?: string | null, title?: string | null, images: Array<{ id: any, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'SectionImageGalleryTwoRecord', _modelApiKey: string, id: any, images: Array<{ id: any, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'SectionItemDetailRecord', _modelApiKey: string, id: any, leftText?: string | null, html?: string | null } | { __typename: 'SectionJobListingRecord', _modelApiKey: string, sectionId?: string | null, id: any, title?: string | null, subtitle?: string | null } | { __typename: 'SectionLocationRecord', _modelApiKey: string, id: any, title?: string | null, countries: Array<{ name?: string | null, email?: string | null, phone?: string | null, rotationx?: any | null, rotationy?: any | null, texture?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, locations: Array<{ city?: string | null, address?: string | null }> }> } | { __typename: 'SectionLogosListRecord', _modelApiKey: string, id: any, title?: string | null, logos: Array<{ name?: string | null, link?: string | null, logo?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionMediaBlockRecord', _modelApiKey: string, id: any, html?: string | null, mediaPosition?: string | null, mediaStyle?: string | null, title?: string | null, aboveTitle?: string | null, background?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, video?: { id: any, url: string } | null, logo?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMultipleRecord', _modelApiKey: string, id: any, content: Array<{ tagline?: string | null, title?: string | null, body?: string | null, mediaStyle?: string | null, media?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> }> } | { __typename: 'SectionPeopleBlockRecord', _modelApiKey: string, id: any, title?: string | null, aboveTitle?: string | null, background?: string | null, people: Array<{ name?: string | null, lastName?: string | null, role?: string | null, phoneNumber?: string | null, email?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionProjectListRecord', _modelApiKey: string, id: any, itemsPerPage?: any | null, linkMore?: string | null, title?: string | null, categories: Array<{ name?: string | null, id: any }> } | { __typename: 'SectionRelatedArticleRecord', _modelApiKey: string, id: any, title?: string | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, categories: Array<{ id: any, name?: string | null }>, overrideArticles: Array<{ excerpt?: string | null, id: any, title?: string | null, slug?: string | null, category: Array<{ id: any, name?: string | null }>, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionRoadmapRecord', _modelApiKey: string, id: any, title?: string | null, current?: any | null, entries: Array<{ title?: string | null, subtitle?: string | null }> } | { __typename: 'SectionServiceRecord', _modelApiKey: string, id: any, title?: string | null, background?: string | null, animation?: string | null, services: Array<{ title?: string | null, subtitle?: string | null, services?: string | null, description?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> }> } | { __typename: 'SectionSplit1Record', _modelApiKey: string, id: any, title?: string | null, bellowTitle?: string | null, fallbackImage?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, links: Array<{ title?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionSplit2Record', _modelApiKey: string, id: any, title?: string | null, bellowTitle?: string | null, links: Array<{ title?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionSplit3Record', _modelApiKey: string, id: any, aboveTitle?: string | null, links: Array<{ title?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionSplitRecord', _modelApiKey: string, id: any, aboveTitle?: string | null, links: Array<{ title?: string | null, color?: { hex: string } | null, reference?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionSplitTitleRecord', _modelApiKey: string, id: any, title?: string | null, subtitle?: string | null, links: Array<{ title?: string | null, color?: { hex: string } | null, reference?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionTestimonialsListRecord', _modelApiKey: string, id: any, testimonials: Array<{ body?: string | null, name?: string | null, company?: string | null }> } | { __typename: 'SectionTextBlockRecord', _modelApiKey: string, id: any, html?: string | null, title?: string | null, aboveTitle?: string | null, background?: string | null, box1?: string | null, box2?: string | null, box3?: string | null } | { __typename: 'SectionVideoRecord', _modelApiKey: string, id: any, title?: string | null, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null } | { __typename: 'SectionWorldwideRecord', _modelApiKey: string, id: any, title?: string | null, html?: string | null, media?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, mediaBlocks: Array<{ _modelApiKey: string, id: any, loop?: any | null, autoplay?: any | null, media?: { url: string } | null }>, countries: Array<{ name?: string | null, email?: string | null, phone?: string | null }> }>, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type JobsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  publishTranslation?: InputMaybe<Scalars['BooleanType']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobsQuery = { _allJobsMeta: { count: any }, allJobs: Array<{ title?: string | null, description?: string | null, location?: string | null, linkedinUrl?: string | null, pinned?: any | null, slug?: string | null }> };

export type JobQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobQuery = { job?: { _modelApiKey: string, id: any, createdAt: any, title?: string | null, description?: string | null, location?: string | null, countrySelector?: any | null, linkedinUrl?: string | null, slug?: string | null, body?: string | null, noIndex?: any | null, publishTranslation?: any | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type PagesQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  publishTranslation?: InputMaybe<Scalars['BooleanType']['input']>;
}>;


export type PagesQuery = { allPages: Array<{ id: any, slug?: string | null, title?: string | null, publishTranslation?: any | null, noIndex?: any | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null }> };

export type PageQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type PageQuery = { page?: { _modelApiKey: string, simpleMenu?: any | null, id: any, slug?: string | null, title?: string | null, publishTranslation?: any | null, noIndex?: any | null, _allSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, hero: Array<{ __typename: 'SectionHeroB1Record', _modelApiKey: string, tag?: string | null, title?: string | null, body?: string | null, parallaxVariant?: string | null, heroVideo?: { id: any, title?: string | null, url: string } | null, layers: Array<{ media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, desktopMedia?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionHeroItemRecord', _modelApiKey: string, client?: string | null, project?: string | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionHeroRecord', _modelApiKey: string, title?: string | null, html?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, heroVideo?: { id: any, title?: string | null, url: string } | null, heroVideoWebm?: { id: any, title?: string | null, url: string } | null, layers: Array<{ media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, desktopMedia?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionHeroSimpleRecord', _modelApiKey: string, tag?: string | null, title?: string | null, html?: string | null, background?: string | null, tagLink?: { __typename: 'PageRecord', id: any, slug?: string | null } | null, subpages: Array<{ __typename: 'PageRecord', id: any, slug?: string | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, person?: { name?: string | null, lastName?: string | null, role?: string | null, phoneNumber?: string | null, email?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | null } | { __typename: 'SectionTitle2Record', _modelApiKey: string, createdAt: any, title?: string | null, aboveTitle?: string | null } | { __typename: 'SectionTitleRecord', _modelApiKey: string, title?: string | null, html?: string | null }>, blocks: Array<{ __typename: 'AccordionListRecord' } | { __typename: 'SectionArticleListRecord', _modelApiKey: string, id: any, itemsPerPage?: any | null, linkMore?: string | null, title?: string | null, categories: Array<{ name?: string | null, id: any }> } | { __typename: 'SectionBodyRecord', _modelApiKey: string, id: any, body?: { value: any, blocks: Array<{ __typename: 'AccordionListRecord', id: any, primary?: any | null, accordions: Array<{ title?: string | null, body?: string | null }> } | { __typename: 'BlockButtonRecord', id: any, label?: string | null, variant?: string | null, extLink?: string | null, intLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'BlockHtmlRecord', id: any, code?: string | null } | { __typename: 'CtaRecord' } | { __typename: 'HighlightImageRecord', id: any, style?: string | null, tag?: string | null, title?: string | null, background?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HighlightQuoteRecord', id: any, title?: string | null } | { __typename: 'ImageGalleryRecord', id: any, images: Array<{ responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'ImageRecord', id: any, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'TableRecord', id: any, table?: any | null } | { __typename: 'VideoEmbedRecord', id: any, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null }> } | null } | { __typename: 'SectionClientListRecord', _modelApiKey: string, id: any, title?: string | null, clientList?: any | null, background?: string | null } | { __typename: 'SectionClientNumberListRecord', _modelApiKey: string, id: any, statistics: Array<{ title?: string | null, number?: string | null }> } | { __typename: 'SectionContactFormRecord', _modelApiKey: string, id: any, html?: string | null, title?: string | null, simple?: any | null, thankYouTitle?: string | null, thankYouSubtitle?: string | null, countries: Array<{ name?: string | null, email?: string | null, phone?: string | null, locations: Array<{ city?: string | null, address?: string | null }> }> } | { __typename: 'SectionCtaRecord', _modelApiKey: string, id: any, background?: string | null, title?: string | null, linkText?: string | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'SectionFeaturesListRecord', _modelApiKey: string, id: any, title?: string | null, background?: string | null, features: Array<{ title?: string | null, body?: string | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, mediaBlocks: Array<{ _modelApiKey: string, id: any, loop?: any | null, autoplay?: any | null, media?: { url: string } | null }>, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionHighlightRecord', _modelApiKey: string, id: any, title?: string | null, leftColumn: Array<{ __typename: 'HighlightImageRecord', style?: string | null, tag?: string | null, title?: string | null, background?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { __typename: 'HighlightQuoteRecord', title?: string | null }>, rightColumn: Array<{ style?: string | null, tag?: string | null, title?: string | null, background?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | { title?: string | null }> } | { __typename: 'SectionImageGalleryRecord', _modelApiKey: string, id: any, background?: string | null, title?: string | null, images: Array<{ id: any, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'SectionImageGalleryTwoRecord', _modelApiKey: string, id: any, images: Array<{ id: any, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null }> } | { __typename: 'SectionItemDetailRecord', _modelApiKey: string, id: any, leftText?: string | null, html?: string | null } | { __typename: 'SectionJobListingRecord', _modelApiKey: string, sectionId?: string | null, id: any, title?: string | null, subtitle?: string | null } | { __typename: 'SectionLocationRecord', _modelApiKey: string, id: any, title?: string | null, countries: Array<{ name?: string | null, email?: string | null, phone?: string | null, rotationx?: any | null, rotationy?: any | null, texture?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, locations: Array<{ city?: string | null, address?: string | null }> }> } | { __typename: 'SectionLogosListRecord', _modelApiKey: string, id: any, title?: string | null, logos: Array<{ name?: string | null, link?: string | null, logo?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionMediaBlockRecord', _modelApiKey: string, id: any, html?: string | null, mediaPosition?: string | null, mediaStyle?: string | null, title?: string | null, aboveTitle?: string | null, background?: string | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, media?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, video?: { id: any, url: string } | null, logo?: { alt?: string | null, url: string, width?: any | null, height?: any | null, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | { __typename: 'SectionMultipleRecord', _modelApiKey: string, id: any, content: Array<{ tagline?: string | null, title?: string | null, body?: string | null, mediaStyle?: string | null, media?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, buttons: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> }> } | { __typename: 'SectionPeopleBlockRecord', _modelApiKey: string, id: any, title?: string | null, aboveTitle?: string | null, background?: string | null, people: Array<{ name?: string | null, lastName?: string | null, role?: string | null, phoneNumber?: string | null, email?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionProjectListRecord', _modelApiKey: string, id: any, itemsPerPage?: any | null, linkMore?: string | null, title?: string | null, categories: Array<{ name?: string | null, id: any }> } | { __typename: 'SectionRelatedArticleRecord', _modelApiKey: string, id: any, title?: string | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }>, categories: Array<{ id: any, name?: string | null }>, overrideArticles: Array<{ excerpt?: string | null, id: any, title?: string | null, slug?: string | null, category: Array<{ id: any, name?: string | null }>, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> } | { __typename: 'SectionRoadmapRecord', _modelApiKey: string, id: any, title?: string | null, current?: any | null, entries: Array<{ title?: string | null, subtitle?: string | null }> } | { __typename: 'SectionServiceRecord', _modelApiKey: string, id: any, title?: string | null, background?: string | null, animation?: string | null, services: Array<{ title?: string | null, subtitle?: string | null, services?: string | null, description?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, button: Array<{ externalLink?: string | null, id: any, primary?: any | null, title?: string | null, hash?: string | null, pageLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null }> }> } | { __typename: 'SectionSplit1Record', _modelApiKey: string, id: any, title?: string | null, bellowTitle?: string | null, fallbackImage?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, links: Array<{ title?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionSplit2Record', _modelApiKey: string, id: any, title?: string | null, bellowTitle?: string | null, links: Array<{ title?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionSplit3Record', _modelApiKey: string, id: any, aboveTitle?: string | null, links: Array<{ title?: string | null, image?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, link?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionSplitRecord', _modelApiKey: string, id: any, aboveTitle?: string | null, links: Array<{ title?: string | null, color?: { hex: string } | null, reference?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionSplitTitleRecord', _modelApiKey: string, id: any, title?: string | null, subtitle?: string | null, links: Array<{ title?: string | null, color?: { hex: string } | null, reference?: { __typename: 'PageRecord', id: any, slug?: string | null } | null }> } | { __typename: 'SectionTestimonialsListRecord', _modelApiKey: string, id: any, testimonials: Array<{ body?: string | null, name?: string | null, company?: string | null }> } | { __typename: 'SectionTextBlockRecord', _modelApiKey: string, id: any, html?: string | null, title?: string | null, aboveTitle?: string | null, background?: string | null, box1?: string | null, box2?: string | null, box3?: string | null } | { __typename: 'SectionVideoRecord', _modelApiKey: string, id: any, title?: string | null, video?: { url: string, title: string, thumbnailUrl: string, height: any, provider: string, providerUid: string, width: any } | null } | { __typename: 'SectionWorldwideRecord', _modelApiKey: string, id: any, title?: string | null, html?: string | null, media?: { responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null, mediaBlocks: Array<{ _modelApiKey: string, id: any, loop?: any | null, autoplay?: any | null, media?: { url: string } | null }>, countries: Array<{ name?: string | null, email?: string | null, phone?: string | null }> }>, simpleMenuCta?: { __typename: 'BlockButtonRecord', id: any, label?: string | null, variant?: string | null, extLink?: string | null, intLink?: { __typename: 'ArticleRecord', id: any, slug?: string | null } | { __typename: 'PageRecord', id: any, slug?: string | null } | null } | null, simpleLogoReference?: { __typename: 'PageRecord', id: any, slug?: string | null } | null, seo: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type ProjectsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  skip?: InputMaybe<Scalars['IntType']['input']>;
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>> | InputMaybe<Scalars['ItemId']['input']>>;
}>;


export type ProjectsQuery = { _allProjectsMeta: { count: any }, allProjects: Array<{ id: any, title?: string | null, client?: string | null, location?: string | null, performedActivities?: string | null, description?: string | null, duration?: string | null, projectCategory?: { id: any, name?: string | null } | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, mimeType: string, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null }> };

export type ProjectQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type ProjectQuery = { project?: { _modelApiKey: string, createdAt: any, id: any, title?: string | null, client?: string | null, location?: string | null, performedActivities?: string | null, description?: string | null, duration?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null, _allPublishTranslationLocales?: Array<{ value?: any | null, locale?: SiteLocale | null }> | null, projectCategory?: { id: any, name?: string | null } | null, image?: { alt?: string | null, url: string, width?: any | null, height?: any | null, mimeType: string, responsiveImage?: { srcSet: string, webpSrcSet: string, sizes: string, src: string, width: any, height: any, aspectRatio: any, alt?: string | null, title?: string | null, bgColor?: string | null, base64?: string | null } | null } | null } | null };

export const ImageFragmentDoc = gql`
    fragment Image on ResponsiveImage {
  srcSet
  webpSrcSet
  sizes
  src
  width
  height
  aspectRatio
  alt
  title
  bgColor
  base64
}
    `;
export const CallToActionFragmentDoc = gql`
    fragment CallToAction on CtaRecord {
  externalLink
  id
  pageLink {
    __typename
    ... on ArticleRecord {
      id
      slug
    }
    ... on PageRecord {
      id
      slug
    }
  }
  primary
  title
  hash
}
    `;
export const SectionBlocksFragmentDoc = gql`
    fragment SectionBlocks on PageModelBlocksField {
  ... on SectionCtaRecord {
    _modelApiKey
    id
    background
    title
    linkText
    link {
      ... on PageRecord {
        id
        __typename
        slug
      }
    }
  }
  ... on SectionBodyRecord {
    _modelApiKey
    id
    body {
      blocks {
        __typename
        ... on BlockButtonRecord {
          id
          __typename
          label
          variant
          intLink {
            ... on ArticleRecord {
              id
              __typename
              slug
            }
            ... on PageRecord {
              id
              __typename
              slug
            }
          }
          extLink
        }
        ... on BlockHtmlRecord {
          id
          code
        }
        ... on ImageRecord {
          id
          image {
            responsiveImage {
              ...Image
            }
          }
        }
        ... on ImageGalleryRecord {
          id
          images {
            responsiveImage(
              imgixParams: {auto: format, crop: focalpoint, fit: crop, ar: "16:9"}
            ) {
              ...Image
            }
          }
        }
        ... on VideoEmbedRecord {
          id
          video {
            url
            title
            thumbnailUrl
            height
            provider
            providerUid
            width
          }
        }
        ... on TableRecord {
          id
          table
        }
        ... on AccordionListRecord {
          id
          accordions {
            title
            body
          }
          primary
        }
        ... on HighlightQuoteRecord {
          id
          title
        }
        ... on HighlightImageRecord {
          id
          __typename
          style
          tag
          title
          background {
            responsiveImage(
              imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1200}
            ) {
              ...Image
            }
          }
          link {
            ... on PageRecord {
              id
              __typename
              slug
            }
            ... on ArticleRecord {
              id
              __typename
              slug
            }
          }
        }
      }
      value
    }
  }
  ... on SectionArticleListRecord {
    _modelApiKey
    __typename
    id
    categories {
      name
      id
    }
    itemsPerPage
    linkMore
    title
  }
  ... on SectionProjectListRecord {
    _modelApiKey
    __typename
    id
    categories {
      name
      id
    }
    itemsPerPage
    linkMore
    title
  }
  ... on SectionImageGalleryRecord {
    _modelApiKey
    id
    background
    images {
      id
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 1200}
      ) {
        ...Image
      }
    }
    title
  }
  ... on SectionImageGalleryTwoRecord {
    _modelApiKey
    id
    images {
      id
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 1200}
      ) {
        ...Image
      }
    }
  }
  ... on SectionContactFormRecord {
    _modelApiKey
    id
    html
    title
    simple
    thankYouTitle
    thankYouSubtitle
    countries {
      name
      email
      phone
      locations {
        city
        address
      }
    }
  }
  ... on SectionFeaturesListRecord {
    _modelApiKey
    id
    title
    features {
      title
      body
      image {
        alt
        url
        width
        height
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "1:1"}
        ) {
          ...Image
        }
      }
      mediaBlocks {
        ... on LottieRecord {
          _modelApiKey
          id
          loop
          autoplay
          media {
            url
          }
        }
      }
      link {
        ... on PageRecord {
          id
          __typename
          slug
        }
      }
    }
    image {
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1200}
      ) {
        ...Image
      }
    }
    background
  }
  ... on SectionLogosListRecord {
    _modelApiKey
    id
    title
    logos {
      name
      logo {
        alt
        url
        width
        height
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, h: 28}
        ) {
          ...Image
        }
      }
      link
    }
  }
  ... on SectionMediaBlockRecord {
    _modelApiKey
    id
    buttons {
      ...CallToAction
    }
    html
    media {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 920, ar: "1:1"}
      ) {
        ...Image
      }
    }
    video {
      id
      url
    }
    logo {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, h: 64}
      ) {
        ...Image
      }
    }
    mediaPosition
    mediaStyle
    title
    aboveTitle
    background
  }
  ... on SectionRelatedArticleRecord {
    _modelApiKey
    id
    button {
      ...CallToAction
    }
    categories {
      id
      name
    }
    overrideArticles {
      category {
        id
        name
      }
      excerpt
      id
      title
      slug
      image {
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 608}
        ) {
          ...Image
        }
      }
    }
    title
  }
  ... on SectionTestimonialsListRecord {
    _modelApiKey
    id
    testimonials {
      body
      name
      company
    }
  }
  ... on SectionVideoRecord {
    _modelApiKey
    id
    title
    video {
      url
      title
      thumbnailUrl
      height
      provider
      providerUid
      width
    }
  }
  ... on SectionTextBlockRecord {
    _modelApiKey
    id
    html
    title
    aboveTitle
    background
    box1
    box2
    box3
  }
  ... on SectionPeopleBlockRecord {
    _modelApiKey
    id
    title
    aboveTitle
    background
    people {
      image {
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 236}
        ) {
          ...Image
        }
      }
      name
      lastName
      role
      phoneNumber
      email
    }
  }
  ... on SectionItemDetailRecord {
    _modelApiKey
    id
    leftText
    html
  }
  ... on SectionSplit1Record {
    _modelApiKey
    id
    title
    bellowTitle
    fallbackImage {
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 600}
      ) {
        ...Image
      }
    }
    links {
      title
      image {
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "1:1", w: 600}
        ) {
          ...Image
        }
      }
      link {
        ... on PageRecord {
          id
          __typename
          slug
        }
      }
    }
  }
  ... on SectionSplit2Record {
    _modelApiKey
    id
    title
    bellowTitle
    links {
      title
      image {
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1200}
        ) {
          ...Image
        }
      }
      link {
        ... on PageRecord {
          id
          __typename
          slug
        }
      }
    }
  }
  ... on SectionSplit3Record {
    _modelApiKey
    id
    aboveTitle
    links {
      title
      image {
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1200}
        ) {
          ...Image
        }
      }
      link {
        ... on PageRecord {
          id
          __typename
          slug
        }
      }
    }
  }
  ... on SectionSplitTitleRecord {
    _modelApiKey
    id
    title
    subtitle
    links {
      title
      color {
        hex
      }
      reference {
        ... on PageRecord {
          id
          __typename
          slug
        }
      }
    }
  }
  ... on SectionSplitRecord {
    _modelApiKey
    id
    aboveTitle
    links {
      title
      color {
        hex
      }
      reference {
        ... on PageRecord {
          id
          __typename
          slug
        }
      }
    }
  }
  ... on SectionHighlightRecord {
    _modelApiKey
    id
    title
    leftColumn {
      ... on HighlightQuoteRecord {
        __typename
        title
      }
      ... on HighlightImageRecord {
        __typename
        style
        tag
        title
        background {
          responsiveImage(
            imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1200}
          ) {
            ...Image
          }
        }
        link {
          ... on PageRecord {
            id
            __typename
            slug
          }
          ... on ArticleRecord {
            id
            __typename
            slug
          }
        }
      }
    }
    rightColumn {
      ... on HighlightQuoteRecord {
        title
      }
      ... on HighlightImageRecord {
        style
        tag
        title
        background {
          responsiveImage(
            imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1200}
          ) {
            ...Image
          }
        }
        link {
          ... on PageRecord {
            id
            __typename
            slug
          }
          ... on ArticleRecord {
            id
            __typename
            slug
          }
        }
      }
    }
  }
  ... on SectionWorldwideRecord {
    _modelApiKey
    id
    title
    html
    media {
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1200}
      ) {
        ...Image
      }
    }
    mediaBlocks {
      ... on LottieRecord {
        _modelApiKey
        id
        loop
        autoplay
        media {
          url
        }
      }
    }
    countries {
      name
      email
      phone
    }
  }
  ... on SectionServiceRecord {
    _modelApiKey
    id
    title
    background
    animation
    services {
      title
      subtitle
      services
      description
      image {
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1200}
        ) {
          ...Image
        }
      }
      button {
        ...CallToAction
      }
    }
  }
  ... on SectionLocationRecord {
    _modelApiKey
    id
    title
    countries {
      name
      email
      phone
      rotationx
      rotationy
      texture {
        responsiveImage(imgixParams: {auto: compress}) {
          ...Image
        }
      }
      locations {
        city
        address
      }
    }
  }
  ... on SectionMultipleRecord {
    _modelApiKey
    id
    content {
      tagline
      title
      body
      media {
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 600, ar: "1:1"}
        ) {
          ...Image
        }
      }
      mediaStyle
      buttons {
        ...CallToAction
      }
    }
  }
  ... on SectionClientNumberListRecord {
    _modelApiKey
    id
    statistics {
      title
      number
    }
  }
  ... on SectionClientListRecord {
    _modelApiKey
    id
    title
    clientList
    background
  }
  ... on SectionRoadmapRecord {
    _modelApiKey
    id
    title
    current
    entries {
      title
      subtitle
    }
  }
  ... on SectionJobListingRecord {
    _modelApiKey
    sectionId
    id
    title
    subtitle
  }
}
    `;
export const PageFragmentDoc = gql`
    fragment Page on PageRecord {
  _allSlugLocales {
    value
    locale
  }
  id
  slug
  title
  publishTranslation
  noIndex
}
    `;
export const HeroBlocksFragmentDoc = gql`
    fragment HeroBlocks on PageModelHeroField {
  ... on SectionHeroRecord {
    _modelApiKey
    title
    html
    buttons {
      ...CallToAction
    }
    heroVideo {
      id
      title
      url
    }
    heroVideoWebm {
      id
      title
      url
    }
    layers {
      media {
        alt
        url
        width
        height
        responsiveImage(imgixParams: {fm: webp, fit: crop, w: 650, ar: "1:2"}) {
          ...Image
        }
      }
      desktopMedia {
        alt
        url
        width
        height
        responsiveImage(imgixParams: {fm: webp, fit: crop, w: 1280, ar: "2:1"}) {
          ...Image
        }
      }
    }
  }
  ... on SectionTitleRecord {
    _modelApiKey
    title
    html
  }
  ... on SectionTitle2Record {
    _modelApiKey
    createdAt
    title
    aboveTitle
  }
  ... on SectionHeroItemRecord {
    _modelApiKey
    client
    project
    image {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1920}
      ) {
        ...Image
      }
    }
  }
  ... on SectionHeroSimpleRecord {
    _modelApiKey
    tag
    tagLink {
      ... on PageRecord {
        id
        __typename
        slug
      }
    }
    subpages {
      ... on PageRecord {
        id
        __typename
        slug
      }
    }
    title
    html
    media {
      alt
      url
      width
      height
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1920}
      ) {
        ...Image
      }
    }
    background
    buttons {
      ...CallToAction
    }
    person {
      image {
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 236}
        ) {
          ...Image
        }
      }
      name
      lastName
      role
      phoneNumber
      email
    }
  }
  ... on SectionHeroB1Record {
    _modelApiKey
    tag
    title
    body
    parallaxVariant
    heroVideo {
      id
      title
      url
    }
    layers {
      media {
        alt
        url
        width
        height
        responsiveImage(imgixParams: {auto: compress, fit: crop, w: 650, ar: "1:2"}) {
          ...Image
        }
      }
      desktopMedia {
        alt
        url
        width
        height
        responsiveImage(imgixParams: {auto: compress, fit: crop, w: 1920, ar: "2:1"}) {
          ...Image
        }
      }
    }
  }
}
    `;
export const AppDocument = gql`
    query app($locale: SiteLocale, $first: IntType = 100, $publishTranslation: BooleanType = true) {
  _site {
    globalSeo {
      siteName
      titleSuffix
    }
    favicon {
      url
    }
    faviconMetaTags {
      tag
      content
      attributes
    }
    locales
  }
  allMenus(
    first: $first
    locale: $locale
    filter: {publishTranslation: {eq: $publishTranslation}}
  ) {
    id
    title
    large
    reference {
      __typename
      ... on PageRecord {
        title
        slug
      }
    }
    externalLink
    separatorTitle
    blocks {
      ... on MenuAdvancedBlockRecord {
        title
        description
        reference {
          __typename
          ... on ArticleRecord {
            title
            slug
          }
          ... on PageRecord {
            title
            slug
          }
          ... on ProjectRecord {
            title
            slug
          }
        }
        externalLink
        sublinks {
          ... on MenuBlockRecord {
            title
            reference {
              __typename
              ... on ArticleRecord {
                title
                slug
              }
              ... on PageRecord {
                title
                slug
              }
              ... on ProjectRecord {
                title
                slug
              }
            }
            externalLink
          }
        }
        secondarySublinks {
          ... on MenuBlockRecord {
            title
            reference {
              __typename
              ... on ArticleRecord {
                title
                slug
              }
              ... on PageRecord {
                title
                slug
              }
              ... on ProjectRecord {
                title
                slug
              }
            }
            externalLink
          }
        }
      }
    }
    publishTranslation
  }
  allMenuCtas(locale: $locale) {
    title
    pageLink {
      __typename
      ... on PageRecord {
        title
        slug
      }
    }
    primary
    externalLink
  }
  allMenuCorporates(
    locale: $locale
    filter: {publishTranslation: {eq: $publishTranslation}}
  ) {
    title
    reference {
      __typename
      ... on PageRecord {
        title
        slug
      }
    }
    externalLink
    publishTranslation
  }
  allMenuFooters(
    locale: $locale
    filter: {publishTranslation: {eq: $publishTranslation}}
  ) {
    id
    title
    externalLink
    large
    reference {
      __typename
      ... on PageRecord {
        title
        slug
      }
    }
    sublinks {
      ... on MenuBlockRecord {
        title
        reference {
          __typename
          ... on ArticleRecord {
            title
            slug
          }
          ... on PageRecord {
            title
            slug
          }
          ... on ProjectRecord {
            title
            slug
          }
        }
        externalLink
      }
    }
    publishTranslation
  }
  allCategories(locale: $locale) {
    _modelApiKey
    id
    name
  }
  allProjectCategories(locale: $locale) {
    _modelApiKey
    id
    name
  }
  allCountries(locale: $locale) {
    name
    email
    phone
  }
}
    `;
export const ArticlesDocument = gql`
    query articles($locale: SiteLocale, $first: IntType, $skip: IntType, $eq: [ItemId], $neq: String, $anyIn: [ItemId], $publishTranslation: BooleanType = true) {
  _allArticlesMeta(
    locale: $locale
    filter: {category: {allIn: $eq}, publishTranslation: {eq: $publishTranslation}, slug: {neq: $neq}}
  ) {
    count
  }
  allArticles(
    locale: $locale
    first: $first
    skip: $skip
    filter: {category: {allIn: $eq, anyIn: $anyIn}, publishTranslation: {eq: $publishTranslation}, slug: {neq: $neq}}
    orderBy: _firstPublishedAt_DESC
  ) {
    category {
      id
      name
    }
    excerpt
    id
    image {
      alt
      url
      width
      height
      mimeType
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 1920}
      ) {
        ...Image
      }
    }
    title
    slug
    publishTranslation
    noIndex
  }
}
    ${ImageFragmentDoc}`;
export const ArticleDocument = gql`
    query article($locale: SiteLocale, $slug: String) {
  article(locale: $locale, filter: {slug: {eq: $slug}}) {
    _allSlugLocales {
      value
      locale
    }
    _allPublishTranslationLocales {
      value
      locale
    }
    _modelApiKey
    author
    createdAt
    category {
      id
      name
    }
    id
    excerpt
    body {
      blocks {
        __typename
        ... on BlockButtonRecord {
          id
          __typename
          label
          variant
          intLink {
            ... on ArticleRecord {
              id
              __typename
              slug
            }
            ... on PageRecord {
              id
              __typename
              slug
            }
          }
          extLink
        }
        ... on BlockHtmlRecord {
          id
          code
        }
        ... on ImageRecord {
          id
          image {
            responsiveImage {
              ...Image
            }
          }
        }
        ... on ImageGalleryRecord {
          id
          images {
            alt
            url
            width
            height
            mimeType
            responsiveImage(
              imgixParams: {auto: format, crop: focalpoint, fit: crop, ar: "16:9"}
            ) {
              ...Image
            }
          }
        }
        ... on VideoEmbedRecord {
          id
          video {
            url
            title
            thumbnailUrl
            height
            provider
            providerUid
            width
          }
        }
        ... on TableRecord {
          id
          table
        }
        ... on AccordionListRecord {
          id
          accordions {
            title
            body
          }
          primary
        }
        ... on HighlightQuoteRecord {
          id
          title
        }
        ... on HighlightImageRecord {
          id
          __typename
          style
          tag
          title
          background {
            alt
            url
            width
            height
            mimeType
            responsiveImage(
              imgixParams: {auto: compress, crop: focalpoint, fit: crop, w: 1200}
            ) {
              ...Image
            }
          }
          link {
            ... on PageRecord {
              id
              __typename
              slug
            }
            ... on ArticleRecord {
              id
              __typename
              slug
            }
          }
        }
      }
      value
    }
    image {
      alt
      url
      width
      height
      mimeType
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "21:9", w: 1920}
      ) {
        ...Image
      }
    }
    readTime
    title
    slug
    publishTranslation
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${ImageFragmentDoc}`;
export const ExposedArticlesDocument = gql`
    query exposedArticles($first: IntType, $skip: IntType) {
  _allExposedArticlesMeta {
    count
  }
  allExposedArticles(first: $first, skip: $skip) {
    article {
      category {
        id
        name
      }
      title
      excerpt
      id
      slug
      image {
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 608}
        ) {
          ...Image
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const ExposedProjectsDocument = gql`
    query exposedProjects($first: IntType, $skip: IntType) {
  _allExposedProjectsMeta {
    count
  }
  allExposedProjects(first: $first, skip: $skip) {
    article {
      projectCategory {
        id
        name
      }
      title
      client
      location
      performedActivities
      description
      duration
      id
      image {
        responsiveImage(
          imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 608}
        ) {
          ...Image
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const IndexDocument = gql`
    query index($locale: SiteLocale) {
  index(locale: $locale) {
    _allPublishTranslationLocales {
      value
      locale
    }
    _modelApiKey
    title
    hero {
      __typename
      ...HeroBlocks
    }
    blocks {
      __typename
      ...SectionBlocks
    }
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${HeroBlocksFragmentDoc}
${CallToActionFragmentDoc}
${ImageFragmentDoc}
${SectionBlocksFragmentDoc}`;
export const JobsDocument = gql`
    query jobs($locale: SiteLocale, $first: IntType, $skip: IntType, $publishTranslation: BooleanType = true, $neq: String) {
  _allJobsMeta(
    locale: $locale
    filter: {publishTranslation: {eq: $publishTranslation}, slug: {neq: $neq}}
  ) {
    count
  }
  allJobs(
    locale: $locale
    first: $first
    skip: $skip
    orderBy: _firstPublishedAt_DESC
    filter: {publishTranslation: {eq: $publishTranslation}, slug: {neq: $neq}}
  ) {
    title
    description
    location
    linkedinUrl
    pinned
    slug
  }
}
    `;
export const JobDocument = gql`
    query job($locale: SiteLocale, $slug: String) {
  job(locale: $locale, filter: {slug: {eq: $slug}}) {
    _allSlugLocales {
      value
      locale
    }
    _allPublishTranslationLocales {
      value
      locale
    }
    _modelApiKey
    id
    createdAt
    title
    description
    location
    countrySelector
    linkedinUrl
    slug
    body
    noIndex
    publishTranslation
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    `;
export const PagesDocument = gql`
    query pages($locale: SiteLocale, $first: IntType, $publishTranslation: BooleanType = true) {
  allPages(
    locale: $locale
    first: $first
    filter: {publishTranslation: {eq: $publishTranslation}}
  ) {
    ...Page
  }
}
    ${PageFragmentDoc}`;
export const PageDocument = gql`
    query page($locale: SiteLocale, $slug: String) {
  page(locale: $locale, filter: {slug: {eq: $slug}}) {
    _modelApiKey
    _allSlugLocales {
      locale
      value
    }
    _allPublishTranslationLocales {
      value
      locale
    }
    ...Page
    hero {
      __typename
      ...HeroBlocks
    }
    blocks {
      __typename
      ...SectionBlocks
    }
    simpleMenu
    simpleMenuCta {
      __typename
      ... on BlockButtonRecord {
        id
        __typename
        label
        variant
        intLink {
          ... on ArticleRecord {
            id
            __typename
            slug
          }
          ... on PageRecord {
            id
            __typename
            slug
          }
        }
        extLink
      }
    }
    simpleLogoReference {
      id
      __typename
      slug
    }
    seo: _seoMetaTags {
      attributes
      content
      tag
    }
  }
}
    ${PageFragmentDoc}
${HeroBlocksFragmentDoc}
${CallToActionFragmentDoc}
${ImageFragmentDoc}
${SectionBlocksFragmentDoc}`;
export const ProjectsDocument = gql`
    query projects($locale: SiteLocale, $first: IntType, $skip: IntType, $eq: [ItemId]) {
  _allProjectsMeta(locale: $locale, filter: {projectCategory: {in: $eq}}) {
    count
  }
  allProjects(
    locale: $locale
    first: $first
    skip: $skip
    filter: {projectCategory: {in: $eq}}
  ) {
    id
    title
    projectCategory {
      id
      name
    }
    client
    location
    performedActivities
    description
    duration
    image {
      alt
      url
      width
      height
      mimeType
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 1920}
      ) {
        ...Image
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const ProjectDocument = gql`
    query project($locale: SiteLocale) {
  project(locale: $locale) {
    _allSlugLocales {
      value
      locale
    }
    _allPublishTranslationLocales {
      value
      locale
    }
    _modelApiKey
    createdAt
    id
    title
    client
    location
    performedActivities
    description
    duration
    projectCategory {
      id
      name
    }
    image {
      alt
      url
      width
      height
      mimeType
      responsiveImage(
        imgixParams: {auto: compress, crop: focalpoint, fit: crop, ar: "21:9", w: 1440}
      ) {
        ...Image
      }
    }
  }
}
    ${ImageFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    app(variables?: AppQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppQuery>(AppDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'app', 'query');
    },
    articles(variables?: ArticlesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArticlesQuery>(ArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'articles', 'query');
    },
    article(variables?: ArticleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArticleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArticleQuery>(ArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'article', 'query');
    },
    exposedArticles(variables?: ExposedArticlesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExposedArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExposedArticlesQuery>(ExposedArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exposedArticles', 'query');
    },
    exposedProjects(variables?: ExposedProjectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExposedProjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExposedProjectsQuery>(ExposedProjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exposedProjects', 'query');
    },
    index(variables?: IndexQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IndexQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IndexQuery>(IndexDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'index', 'query');
    },
    jobs(variables?: JobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobsQuery>(JobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'jobs', 'query');
    },
    job(variables?: JobQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobQuery>(JobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'job', 'query');
    },
    pages(variables?: PagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PagesQuery>(PagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pages', 'query');
    },
    page(variables?: PageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PageQuery>(PageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'page', 'query');
    },
    projects(variables?: ProjectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProjectsQuery>(ProjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'projects', 'query');
    },
    project(variables?: ProjectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProjectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProjectQuery>(ProjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'project', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;